import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { PublicRestrictedModal } from './public/PublicRestrictedModal';
import styles from './restricted_modal.module.scss';
import { ExpiredRestrictedModal } from './expired/ExpiredRestrictedModal';
import { useUser } from '../../../../user/useUser';
import { MaterialIcon } from '../../../material-icon/MaterialIcon';

type Props = {
  source: string;
  isOpen?: boolean;
  onRequestClose?: () => void;
  title?: string;
};

export const RestrictedModal: FC<Props> = ({
  onRequestClose = () => {},
  source,
  title,
  isOpen = false,
}) => {
  const { loggedIn } = useUser();
  if (!isOpen) {
    return null;
  }

  const isFeatureRectriction = !!title;

  if (loggedIn) {
    return (
      <ExpiredRestrictedModal
        source={source}
        closeModal={onRequestClose}
        isOpen={isOpen}
      />
    );
  }

  return (
    <PublicRestrictedModal
      source={source}
      closeModal={onRequestClose}
      isOpen={isOpen}
      title={
        isFeatureRectriction ? (
          title
        ) : (
          <FormattedMessage
            id="modal-restricted/RestrictedModal.tsx/1"
            values={{ br: <br /> }}
          />
        )
      }
      subtitle={
        isFeatureRectriction ? (
          <FormattedMessage
            id="modal-restricted/RestrictedModal.tsx/1"
            values={{ br: <br /> }}
          />
        ) : null
      }
      icon={
        isFeatureRectriction ? (
          <MaterialIcon name="lock" className={styles.featureRestrictionIcon} />
        ) : (
          <span className={styles.logo} />
        )
      }
    />
  );
};
